import { arcadia } from '../../config';
import ItemImage from './image';

const ItemLink = ({ item }) => {
	return (
		<span className={'item__link'}>
			<ItemImage item={item} />
			<span>{item.name}</span>
			<a
				href={`${arcadia.cp.url}/item/view/?id=${item.id}`}
				target={'_blank'}
				rel={'noopener noreferrer'}
			>
				<img
					src={'./assets/icon--item-db.svg'}
					alt={`Item Database: ${item.name}`}
					title={`Item Database: ${item.name}`}
					className={'icon'}
				/>
			</a>
			<a
				href={`${arcadia.cp.url}/market/vending/?item_id=${item.id}`}
				target={'_blank'}
				rel={'noopener noreferrer'}
			>
				<img
					src={'./assets/icon--item-vend.svg'}
					alt={`Venders: ${item.name}`}
					title={`Venders: ${item.name}`}
					className={'icon'}
				/>
			</a>
		</span>
	);
};

export default ItemLink;
